import { render, staticRenderFns } from "./NavigationCategories.vue?vue&type=template&id=10c9df98&scoped=true&"
import script from "./NavigationCategories.vue?vue&type=script&lang=js&"
export * from "./NavigationCategories.vue?vue&type=script&lang=js&"
import style0 from "./NavigationCategories.vue?vue&type=style&index=0&id=10c9df98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c9df98",
  null
  
)

export default component.exports